import React, { useState, useEffect } from 'react';
import Header from '../../componentes/header/header';
import { Helmet } from "react-helmet";
import FinalComponent from "../../componentes/EndPage/Final";
import instagramProfiles from './instagramProfiles.json';
import translations from './traducao.json';

function Instagram() {
    const [lang, setLang] = useState(localStorage.getItem("siteLanguage") || "pt");
    const [profiles, setProfiles] = useState([]);
    const [loading, setLoading] = useState(true);

    const handleLanguageChange = (newLang) => {
        setLang(newLang);
        localStorage.setItem("siteLanguage", newLang);
        window.location.reload();
    };

    useEffect(() => {
        const browserLang = navigator.language.split("-")[0];
        if (!localStorage.getItem("siteLanguage")) {
            localStorage.setItem("siteLanguage", browserLang);
        }
        
        // Simular carregamento dos perfis
        setTimeout(() => {
            setProfiles(instagramProfiles.profiles);
            setLoading(false);
        }, 1000);
    }, []);

    const translation = translations[lang] || translations["pt"];

    const handleOpenProfile = (url) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    return (
        <>
            <Helmet>
                <title>{translation?.instagram_title || "Instagram"} | SOBREVIDAS-ACS</title>
            </Helmet>
            <Header handleLanguageChange={handleLanguageChange} />

            <div className="min-h-screen bg-gradient-to-br from-purple-50 to-pink-50">
                <div className="container mx-auto px-4 py-8">
                    {/* Header Section */}
                    <div className="text-center mb-12">
                        <h1 className="text-4xl md:text-5xl font-black text-[#B040B1] mb-4">
                            {translation?.instagram_title || "Instagram"}
                        </h1>
                        <div className="relative inline-block">
                            <span className="absolute bottom-[-1px] left-[-55%] w-[200%] h-[45px] bg-gradient-to-r from-[rgba(106,13,173,0.4)] to-[rgba(255,102,178,0.4)] shadow-[5px_5px_10px_rgba(0,0,0,0.2)] -z-20 rounded-[50px]"></span>
                        </div>
                        <p className="text-xl text-gray-600 mt-6 max-w-2xl mx-auto">
                            {translation?.instagram_subtitle || "Conecte-se conosco nas redes sociais"}
                        </p>
                        <p className="text-lg text-gray-500 mt-4 max-w-3xl mx-auto">
                            {translation?.instagram_description || "Acompanhe nossas atividades e novidades através dos nossos perfis oficiais no Instagram"}
                        </p>
                    </div>

                    {/* Loading State */}
                    {loading && (
                        <div className="flex justify-center items-center py-20">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#B040B1]"></div>
                            <span className="ml-4 text-lg text-gray-600">
                                {translation?.loading || "Carregando perfis..."}
                            </span>
                        </div>
                    )}

                    {/* Profiles Grid */}
                    {!loading && (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
                            {profiles.map((profile) => (
                                <div
                                    key={profile.id}
                                    className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden"
                                >
                                    {/* Profile Header */}
                                    <div className="p-6 border-b border-gray-100">
                                        <div className="flex items-center space-x-4">
                                            <div className="w-16 h-16 bg-gradient-to-br from-purple-400 to-pink-400 rounded-full flex items-center justify-center">
                                                <span className="text-white font-bold text-xl">
                                                    {profile.name.charAt(0)}
                                                </span>
                                            </div>
                                            <div className="flex-1">
                                                <div className="flex items-center space-x-2">
                                                    <h3 className="text-lg font-bold text-gray-800">
                                                        @{profile.username}
                                                    </h3>
                                                    {profile.isVerified && (
                                                        <span className="text-blue-500 text-sm">
                                                            ✓ {translation?.verified || "Verificado"}
                                                        </span>
                                                    )}
                                                </div>
                                                <p className="text-sm text-gray-500">
                                                    {profile.followers} {translation?.followers || "seguidores"}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Profile Content */}
                                    <div className="p-6">
                                        <h4 className="text-xl font-semibold text-gray-800 mb-2">
                                            {profile.name}
                                        </h4>
                                        <p className="text-gray-600 mb-4 line-clamp-3">
                                            {profile.description}
                                        </p>
                                        <div className="mb-4">
                                            <span className="inline-block bg-purple-100 text-purple-800 text-xs px-3 py-1 rounded-full">
                                                {profile.category}
                                            </span>
                                        </div>
                                    </div>

                                    {/* Action Button */}
                                    <div className="p-6 pt-0">
                                        <button
                                            onClick={() => handleOpenProfile(profile.url)}
                                            className="w-full bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white font-semibold py-3 px-6 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
                                        >
                                            {translation?.open_profile || "Abrir Perfil"}
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Empty State */}
                    {!loading && profiles.length === 0 && (
                        <div className="text-center py-20">
                            <div className="text-6xl mb-4">📱</div>
                            <h3 className="text-2xl font-semibold text-gray-600 mb-2">
                                {translation?.no_profiles || "Nenhum perfil encontrado"}
                            </h3>
                            <p className="text-gray-500">
                                Em breve teremos mais perfis disponíveis!
                            </p>
                        </div>
                    )}
                </div>
            </div>

            <FinalComponent />
        </>
    );
}

export default Instagram;
